import { Button } from '@mui/material';

import { ExpressionMetadataModel, SuggestedExpressionMetadata } from '../../../../api/api';
import { ExpressionTypes } from '../../Models/ExpressionTypes';

type Props = {
	suggestions?: SuggestedExpressionMetadata[];
	expressionMetadata: ExpressionMetadataModel[];
	onSelectExpressionType: (expressionType: string) => void;
	onSelectConstValue: (value: unknown) => void;
	onOpenConstEditor: (anchor: HTMLElement) => void;
};

export default function ExpressionSuggestionShortcuts({ suggestions, expressionMetadata, onSelectExpressionType, onSelectConstValue, onOpenConstEditor }: Props) {
	if (!suggestions?.length) {
		return null;
	}

	return (
		<>
			{suggestions.flatMap((suggestion) => {
				if (suggestion.type === ExpressionTypes.Const && suggestion.constValues?.length) {
					return suggestion.constValues.map((value, index) => (
						<Button
							key={`${suggestion.type}-${typeof value}-${String(value)}-${index}`}
							variant="outlined"
							size="small"
							title={suggestion.displayName}
							onClick={() => onSelectConstValue(value)}
						>
							{String(value)}
						</Button>
					));
				}

				const metadata = expressionMetadata.find((item) => item.name === suggestion.type);
				if (!metadata) {
					return [];
				}

				return [
					<Button
						key={suggestion.type}
						variant="outlined"
						size="small"
						onClick={(event) => {
							if (suggestion.type === ExpressionTypes.Const) {
								onOpenConstEditor(event.currentTarget);
							} else {
								onSelectExpressionType(suggestion.type);
							}
						}}
					>
						{suggestion.displayName || metadata.displayName}
					</Button>,
				];
			})}
		</>
	);
}
